import { ResourceEntity } from "fond/types";

import CityPlannerRowMenu from "./CityPlannerRowMenu";
import CityReportRowMenu from "./CityReportRowMenu";
import FolderRowMenu from "./FolderRowMenu";
import ProjectRowMenu from "./ProjectRowMenu";
import ReportRowMenu from "./ReportRowMenu";
import { CommonItemMenuProps } from "./types";

type EntityMenuProps = CommonItemMenuProps & {
  entity?: ResourceEntity;
};

/**
 * Show the relevant menu for the given entity to allow the user to take actions relevant to that entity.
 */
export const EntityMenu: React.FC<EntityMenuProps> = ({ entity, anchorEl, onMenuClose, source }: EntityMenuProps) => {
  if (!entity) {
    return null;
  }
  const { EntityType } = entity;
  const commonProps = { onMenuClose, anchorEl, source };

  if (EntityType === "report") {
    return <ReportRowMenu report={entity} {...commonProps} />;
  }

  if (EntityType === "project") {
    return <ProjectRowMenu projectPreview={entity} {...commonProps} />;
  }

  if (EntityType === "folder") {
    if (entity.MultiProject) {
      return <CityPlannerRowMenu cityPlannerFolder={entity} {...commonProps} />;
    }
    if (entity.MultiReport) {
      return <CityReportRowMenu cityReportFolder={entity} {...commonProps} />;
    }
    return <FolderRowMenu folder={entity} {...commonProps} />;
  }

  return null;
};
